import { normalizeLocale, type SupportedLocale } from './config';
import type { VoiceToolActivity } from '@/lib/voice-tool-activity';

const COPY: Record<SupportedLocale, Record<VoiceToolActivity, string>> = {
  en: {
    researching: 'Researching…',
    searching: 'Searching…',
    working: 'Working…',
  },
  ar: {
    researching: 'جارٍ البحث المعمّق…',
    searching: 'جارٍ البحث…',
    working: 'جارٍ العمل…',
  },
  de: {
    researching: 'Recherchiert…',
    searching: 'Sucht…',
    working: 'Arbeitet…',
  },
  es: {
    researching: 'Investigando…',
    searching: 'Buscando…',
    working: 'Trabajando…',
  },
  fr: {
    researching: 'Analyse…',
    searching: 'Recherche…',
    working: 'En cours…',
  },
  hi: {
    researching: 'शोध जारी है…',
    searching: 'खोज जारी है…',
    working: 'काम जारी है…',
  },
  id: {
    researching: 'Meneliti…',
    searching: 'Mencari…',
    working: 'Mengerjakan…',
  },
  it: {
    researching: 'Approfondimento…',
    searching: 'Ricerca…',
    working: 'In corso…',
  },
  ja: { researching: '調査中…', searching: '検索中…', working: '作業中…' },
  ko: { researching: '조사 중…', searching: '검색 중…', working: '작업 중…' },
  'pt-BR': {
    researching: 'Pesquisando…',
    searching: 'Buscando…',
    working: 'Trabalhando…',
  },
  ru: {
    researching: 'Исследование…',
    searching: 'Поиск…',
    working: 'В работе…',
  },
  vi: {
    researching: 'Đang nghiên cứu…',
    searching: 'Đang tìm kiếm…',
    working: 'Đang xử lý…',
  },
  zh: { researching: '调研中…', searching: '搜索中…', working: '处理中…' },
  'zh-TW': { researching: '調研中…', searching: '搜尋中…', working: '處理中…' },
};

export function getVoiceToolActivityCopy(locale: string | null | undefined) {
  return COPY[normalizeLocale(locale)];
}
